import { __decorate } from "tslib";
import { id_netscapeCertExtension } from "./object_identifiers";
import { AsnType, AsnTypeTypes, AsnPropTypes, AsnProp } from "@peculiar/asn1-schema";
export const id_netscapeRevocationUrl = `${id_netscapeCertExtension}.3`;
let NetscapeRevocationUrl = class NetscapeRevocationUrl {
    constructor(value) {
        this.value = "";
        if (value) {
            this.value = value;
        }
    }
};
__decorate([
    AsnProp({ type: AsnPropTypes.IA5String })
], NetscapeRevocationUrl.prototype, "value", void 0);
NetscapeRevocationUrl = __decorate([
    AsnType({ type: AsnTypeTypes.Choice })
], NetscapeRevocationUrl);
export { NetscapeRevocationUrl };
